import script from "./chart.vue?vue&type=script&setup=true&lang=js"
export * from "./chart.vue?vue&type=script&setup=true&lang=js"

import "./chart.vue?vue&type=style&index=0&id=d2fed742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2fed742"]])

export default __exports__